import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import { DashCenterActionCreators, IApplicationState, IDonorIntakeFullNameResponse } from '@nkr/store/index';
import { ICenter } from '@nkr/models/index';
import DonorIntakeTabs from './components/tabs';
import DashRegistrationsList from './components/all/list';
import { subSections } from '../subsections';
import ConfirmAddress from '../pwl/confirm-address';
import DonorDetails from './components/details';
import DonorDiagnosisAddEdit from './components/add-edit';
import PwlDetails from './pwl/details';
import { useEffect, useState } from 'react';
import { SearchIntendedRecipient } from './pages/search-intended-recipient';
import { FormSendCannedEmail } from './pages/form-send-canned-email';

interface IOwnProps {
    centerId: number,
    subSection: string,
    isSuperUser: boolean,
    isCenter: boolean,
    regId?: number
}

interface IStateProps {
    center: ICenter
}

interface IDispatchProps {
    getFullName: (registrationId: number) => Promise<IDonorIntakeFullNameResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

const DonorIntake = (props: TProps) => {
    const [fullName, setFullName] = useState('');

    useEffect(() => {
        if (props.regId != null) {
            props.getFullName(props.regId).then(response => {
                setFullName(response.data.results);
            });
        }
    }, []);

    if (props.center == null && !props.isSuperUser)
        return null;

    let showList = [
        subSections.SEARCH_INTENDED,
        subSections.CONFIRM_ADDRESS,
        subSections.DETAILS,
        subSections.SEND_EMAIL,
        subSections.EDIT_DIAGNOSTICS,
        subSections.PWL_DETAILS
    ].indexOf(props.subSection.toUpperCase()) < 0;

    return (
        <div style={{ padding: '0px 10px' }}>
            {props.isSuperUser && (
                <h3 style={{ marginTop: 0 }}>DASH Registration Management</h3>
            )}

            <DonorIntakeTabs
                activeKey={props.subSection}
                center={props.center}
                registrationId={props.regId != null ? props.regId : 0}
                fullname={fullName}
                isSuperAdmin={props.isSuperUser}
                onTabSelect={() => null}
            />

            <div style={{ width: '100%', borderLeft: '1px solid #ddd', borderRight: '1px solid #ddd', borderBottom: '1px solid #ddd', minHeight: '70vh', paddingTop: 10, paddingLeft: 10, paddingRight: 10, marginBottom: 10, backgroundColor: '#FFF' }}>
                {showList && (
                    <DashRegistrationsList
                        subSection={props.subSection.toUpperCase()}
                        centerId={props.centerId}
                        isAdminSection={props.isSuperUser}
                        isCenter={props.isCenter}
                    />
                )}

                {props.subSection.toUpperCase() == subSections.SEARCH_INTENDED && (
                    <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                        <SearchIntendedRecipient />
                    </div>
                )}

                {props.subSection.toUpperCase() == subSections.CONFIRM_ADDRESS && (
                    <ConfirmAddress centerId={props.centerId} />
                )}

                {props.subSection.toUpperCase() == subSections.DETAILS && (
                    <DonorDetails
                        regId={props.regId}
                        centerId={props.centerId}
                        isSuperAdmin={props.isSuperUser}
                    />
                )}

                {props.subSection.toUpperCase() == subSections.SEND_EMAIL && (
                    <FormSendCannedEmail registrationId={props.regId} />
                )}

                {props.subSection.toUpperCase() == subSections.EDIT_DIAGNOSTICS && (
                    <DonorDiagnosisAddEdit
                        regId={props.regId}
                        centerId={props.centerId}
                        isAdmin={true}
                        isConfirm={true}
                        previousUrl={''}
                        previousName={''}
                    />
                )}

                {props.subSection.toUpperCase() == subSections.PWL_DETAILS && (
                    <PwlDetails
                        registrationId={props.regId}
                        centerId={props.centerId}
                        isAdmin={props.isCenter == false}
                    />
                )}
            </div>
        </div>
    );
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        center: appState.app.center
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        getFullName: (registrationId) => {
            return dispatch(DashCenterActionCreators.getFullName(registrationId));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(DonorIntake);
